// @flow
import * as React from 'react';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import Datepicker from 'react-tailwindcss-datepicker';

import { inputClass } from '@/components/ui/input';

type Props = ControllerRenderProps<FieldValues, string>;

export function MotitoDatePicker(props: Props) {
  return (
    <Datepicker
      asSingle
      toggleClassName="absolute right-0 top-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
      displayFormat="DD/MM/YYYY"
      maxDate={new Date()}
      showFooter={false}
      useRange={false}
      inputClassName={inputClass}
      {...props}
      onChange={(date) => {
        props.onChange(date?.endDate);
      }}
      value={{
        startDate: props.value,
        endDate: props.value,
      }}
    />
  );
}
